import { Injectable } from '@angular/core';
import { isNotNumeric, isNumeric } from 'app/shared/common/utils';
import { Language, LogoLocation, LogoRotation, LogoShape, LogoSize, Validators } from 'app/shared/model/enums';
import { CouponStatus } from '../model/enums/status-enum';
import { WebRouletteStatus } from '../model/web-roulette-status';

@Injectable()
export class EnumService {
  private enumNames: Map<any, any>;
  constructor() {
    this.enumNames = new Map();

    this.enumNames.set(Validators, { name: "Validators", values: this.enumValuesToList(Validators) });
    this.enumNames.set(CouponStatus, { name: "CouponStatus", values: this.enumValuesToList(CouponStatus) })
    this.enumNames.set(LogoShape, { name: "LogoShape", values: this.enumValuesToList(LogoShape) })
    this.enumNames.set(LogoLocation, { name: "LogoLocation", values: this.enumValuesToList(LogoLocation) })
    this.enumNames.set(Language, { name: "Language", values: this.enumValuesToList(Language) })
    this.enumNames.set(LogoSize, { name: "LogoSize", values: this.enumValuesToList(LogoSize) })
    this.enumNames.set(LogoRotation, { name: "LogoRotation", values: this.enumValuesToList(LogoRotation) })
    this.enumNames.set(WebRouletteStatus, { name: "WebRouletteStatus", values: this.enumValuesToList(WebRouletteStatus) })

  }

  getEnumName(enumType) {
    return this.enumNames.get(enumType).name;
  }
  getEnumValues(enumType): any[] {
    return this.enumNames.get(enumType).values;
  }
  //return the names of enum values
  enumValuesToList(enumType) {
    return Object.keys(enumType)
      .filter(isNotNumeric)
      .map(key => enumType[key]);
  }
  enumNamesToList(enumType) {
    return Object.keys(enumType)
      .filter(isNumeric)
      .map(key => enumType[key]);
  }
}



